import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Input, Form } from "antd";
import { setInputMode } from "../../services/input";
import { AnnotatedFormItem } from "./AnnotatedFormItem";

export const PhoneNumber2FormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <AnnotatedFormItem label="パートナー様電話番号" annotation="任意">
      <Input
        ref={setInputMode("tel")}
        type="tel"
        value={store.phoneNumber2}
        onChange={e => {
          store.phoneNumber2 = e.target.value;
        }}
      />
    </AnnotatedFormItem>
  );
});
